import { render, staticRenderFns } from "./editHousekeepingServ.vue?vue&type=template&id=28ea775a&scoped=true"
import script from "./editHousekeepingServ.vue?vue&type=script&lang=js"
export * from "./editHousekeepingServ.vue?vue&type=script&lang=js"
import style0 from "./editHousekeepingServ.vue?vue&type=style&index=0&id=28ea775a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea775a",
  null
  
)

export default component.exports